import React, { useContext, useEffect, useMemo } from 'react';
import { useVendingFilterForm } from '../hooks/useVendingFilterForm';


export const VendingFilterContext = React.createContext()

export const VendingFilterProvider = ({ children }) => {
    const state = useVendingFilterForm()
    const value = useMemo(() => state, [state])


    useEffect(() => { console.log("VendingFilterProvider => ", value) }, [value])

    return (
        <VendingFilterContext.Provider value={value}>
            {children}
        </VendingFilterContext.Provider>
    );
}

export function useVendingFilterContext() {
    return useContext(VendingFilterContext)
}
